"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const filterRoutes = (pathname) => (announcement) => {
    const matchingRoute = announcement.routes.find((route) => (0, react_router_dom_1.matchPath)(pathname, {
        path: route,
    }));
    // This funky return check is used so that empty strings are truthy.
    // Yay Javascript -_-
    return Boolean(matchingRoute);
};
const AnnouncementManagerFactory = (announcements) => {
    const AnnouncementManager = (prop) => {
        const { pathname } = (0, react_router_dom_1.useLocation)();
        const [showAnnouncements, updateShowAnnouncements] = (0, react_1.useState)(announcements.map((announcement) => announcement.show(prop)));
        // If a modal is truthy, it has been seen already, so we look for falsy ones
        const activeAnnouncementIndex = (0, react_1.useMemo)(() => announcements
            .filter(filterRoutes(pathname))
            .findIndex((_, index) => showAnnouncements[index]), [pathname, showAnnouncements]);
        if (activeAnnouncementIndex === -1) {
            return null;
        }
        const Modal = announcements[activeAnnouncementIndex].modal;
        const markDontShowAgain = () => updateShowAnnouncements((_showAnnouncements) => _showAnnouncements.map((val, index) => index === activeAnnouncementIndex ? false : val));
        return react_1.default.createElement(Modal, { onClose: markDontShowAgain });
    };
    return AnnouncementManager;
};
exports.default = AnnouncementManagerFactory;
